module.exports = __webpack_public_path__ + "img/girl.4aaad67f.png";